
import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import SpeakersSection from '@/components/SpeakersSection';
import PageHeader from '@/components/PageHeader';
import LogoScroller from '@/components/LogoScroller';

const Speakers = () => {
  return (
    <div className="min-h-screen bg-ai-dark">
      <Helmet>
        <title>Speakers - AI World Congress 2026 - November 25-26, London UK - AI Conference</title>
        <meta name="description" content="Meet the expert speakers at AI World Congress 2026. Industry leaders, pioneers and visionaries shaping the future of AI. November 25-26, London." />
        <link rel="canonical" href="https://aiconference.london/speakers" />
        <meta property="og:title" content="Speakers - AI World Congress 2026 - November 25-26, London UK - AI Conference" />
        <meta property="og:description" content="Meet the expert speakers at AI World Congress 2026. Industry leaders, pioneers and visionaries shaping the future of AI." />
        <meta property="og:url" content="https://aiconference.london/speakers" />
        <meta property="og:image" content="https://aiconference.london/lovable-uploads/og-banner-2026.jpg" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Speakers - AI World Congress 2026 - November 25-26, London UK - AI Conference" />
        <meta name="twitter:description" content="Meet the expert speakers at AI World Congress 2026. Industry leaders shaping the future of AI." />
        <meta name="twitter:image" content="https://aiconference.london/lovable-uploads/og-banner-2026.jpg" />
      </Helmet>
      <Header />
      <PageHeader 
        title=""
        backgroundImage="/lovable-uploads/530fddbf-4fea-4198-860f-8165d2f8b445.png"
      />
      
      <div className="relative z-10 -mt-16">
        <div className="relative py-8 md:py-12 overflow-hidden bg-gradient-to-b from-purple-900/80 to-black">
          <div className="absolute inset-0 w-full h-full overflow-hidden z-0">
            <div className="absolute w-full h-[40%] bottom-0 bg-gradient-to-t from-black to-transparent"></div>
            <div className="absolute w-full h-[500px] bottom-0 left-0 right-0">
              <svg className="absolute bottom-0 w-full" viewBox="0 0 1440 320" xmlns="http://www.w3.org/2000/svg">
                <path 
                  fill="#000000" 
                  fillOpacity="1" 
                  d="M0,128L48,138.7C96,149,192,171,288,176C384,181,480,171,576,144C672,117,768,75,864,80C960,85,1056,139,1152,160C1248,181,1344,171,1392,165.3L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
                  className="animate-pulse"
                  style={{ animationDuration: '15s' }}
                ></path>
              </svg>
            </div>
          </div>
          
          <div className="container mx-auto px-4 relative z-10">
            <div className="text-center max-w-4xl mx-auto">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">
                <span className="text-white">Meet Our </span>
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">Speakers</span>
              </h1>
              
              <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto animate-fade-in" style={{ animationDelay: '0.2s' }}>
                2026 Dates: November 25-26, London. Learn from industry experts, pioneers and visionaries who are shaping the future of AI
              </p>
            </div>
          </div>
        </div>
        <SpeakersSection />
      </div>
      <LogoScroller />
      <Footer />
    </div>
  );
};

export default Speakers;
